import { render, staticRenderFns } from "./FeatureMerge.vue?vue&type=template&id=9ad8999e&scoped=true&lang=pug&"
import script from "./FeatureMerge.vue?vue&type=script&lang=js&"
export * from "./FeatureMerge.vue?vue&type=script&lang=js&"
import style0 from "./FeatureMerge.vue?vue&type=style&index=0&id=9ad8999e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad8999e",
  null
  
)

export default component.exports